import React from 'react';
import { useFeatureSwitch } from '../../../shared/hooks/useFeatureSwitch';
import { GameProvider } from '../context/GameProvider';
import FortressHUD from './FortressHUD';
import ComboNotification from './ComboNotification';
import MorningBriefingPanel from './MorningBriefing';

/**
 * Wraps the app in GameProvider and shows the ambient HUD, combo notification and briefing when
 * the gamification switch is on. The element shape never changes with the switch: swapping the
 * wrapper would remount every route under it (the dashboard, its chat socket, unsaved drafts).
 * GameProvider makes no game calls while the switch is off.
 */
export const GamificationLayer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const gamificationEnabled = useFeatureSwitch('gamification');
  return (
    <GameProvider>
      {gamificationEnabled && <FortressHUD />}
      {children}
      {gamificationEnabled && <ComboNotification />}
      {gamificationEnabled && <MorningBriefingPanel />}
    </GameProvider>
  );
};
